module.exports = __webpack_public_path__ + "static/music-player-background-mob-9985d1133198462b2a5170cce54a36c0.png";